import React from 'react';
import { FormattedMessage } from 'react-intl';

const SoldOut = () => (
  <div className="sold-out-text">
    <FormattedMessage
      id="checkout.sold-out"
      defaultMessage="Sold Out"
    />
  </div>
);

export default SoldOut;
